import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import FormData from 'form-data';
import MapLifeCyclePolicy from 'components/Organisms/Dialog/ActionList/MapLifeCyclePolicy';

import { fetchMapLifeCyclePoliciesAction } from 'api/employees';

const convertData = (data) => {
  return data?.lifeCycleInstanceList
    ?.filter((item) => item.status === 'ACTIVE')
    .map((item) => ({
      id: item.id,
      name: item.name,
      onClick: () => {},
    }));
};

const MapLifeCyclePolicyContainer = ({ open, handleClose, handleComment, selectedEmployee }) => {
  const [items, setItems] = useState([]);
  const [pid, setPid] = useState('');

  const handleChange = (event) => {
    const selectedItem = event.target.value;
    setPid(selectedItem);
  };

  useEffect(() => {
    const fetchMapLifeCyclePolicies = async () => {
      const bodyFormData = new FormData();
      bodyFormData.append('id', selectedEmployee.id);
      const response = await fetchMapLifeCyclePoliciesAction(bodyFormData);
      if (response.status === 200) {
        const transformedData = convertData(response.data);
        setItems(transformedData);
      }
    };

    if (open) fetchMapLifeCyclePolicies();
  }, [selectedEmployee?.id, open]);
  return (
    <MapLifeCyclePolicy
      open={open}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleComment={() => handleComment(selectedEmployee?.id, pid)}
      userName={selectedEmployee?.firstName}
      options={items}
      handleChange={handleChange}
      primaryBtn="Map Policy"
      value={pid}
    />
  );
};

MapLifeCyclePolicyContainer.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleComment: PropTypes.func,
  selectedEmployee: PropTypes.shape({
    firstName: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
};

MapLifeCyclePolicyContainer.defaultProps = {
  handleComment: () => {},
  open: false,
  handleClose: () => {},
};

export default MapLifeCyclePolicyContainer;
